// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"cbd99820","289":"35541e2f","312":"48c60564","640":"5edb82ca","784":"7ece11ee","789":"f50bf4a5","944":"294198d4","986":"ed96600b","987":"bc8aeaa7","998":"a0b12eaf"}[chunkId] + ".chunk.css";
};